import { render, staticRenderFns } from "./warehouse-item.vue?vue&type=template&id=52854dfb&"
import script from "./warehouse-item.vue?vue&type=script&lang=js&"
export * from "./warehouse-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports